import { Injectable } from '@angular/core';
import { Actions, ofActionCompleted, Store } from '@ngxs/store';
import { filter, switchMap } from 'rxjs';

import { AuthState, AuthAction } from '@hiptraveler/data-access/auth';
import { UserAction } from '@hiptraveler/data-access/user';

@Injectable()
export class AuthObserverService {

  constructor(
    private store: Store,
    private actions$: Actions
  ) { }

  /**
   * Handles re-initializing the visitor session's itineraries after a user signs out.
   * 
   * On user sign-out, the current itinerary data is cleared. This method listens for sign-out actions,
   * checks if the user is now unauthenticated, and then dispatches a check for the visitor session
   * to generate a new set of itineraries for the new visitor session.
   */
  handleItineraryResetOnSignOut(): void {
    this.actions$.pipe(
      ofActionCompleted(AuthAction.SignOut, AuthAction.SignOutNoAuth),
      switchMap(() => this.store.select(AuthState.authenticated)),
      filter(isAuthenticated => !isAuthenticated),
      switchMap(() => this.store.dispatch(UserAction.CheckVisitorSession))
    ).subscribe();
  }

}
